import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "@/App.tsx";
import "@/config/index.css";
import { TooltipProvider } from "./components/ui/tooltip";
import { NextUIProvider } from "@nextui-org/react";
import "@/config/i18n";
import "./config/environment";
import "@/hooks/useDebugFlags";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initSentry } from "./lib/sentry";

const queryClient = new QueryClient();

initSentry();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<NextUIProvider>
			<BrowserRouter>
				<QueryClientProvider client={queryClient}>
					<TooltipProvider delayDuration={0}>
						<App />
					</TooltipProvider>
				</QueryClientProvider>
			</BrowserRouter>
		</NextUIProvider>
	</StrictMode>
);
